import { render, staticRenderFns } from "./SearchResultsBlock.vue?vue&type=template&id=4227921d&scoped=true"
import script from "./SearchResultsBlock.vue?vue&type=script&lang=js"
export * from "./SearchResultsBlock.vue?vue&type=script&lang=js"
import style0 from "./SearchResultsBlock.vue?vue&type=style&index=0&id=4227921d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4227921d",
  null
  
)

export default component.exports